import {
  FetchStreetsRequest,
  FetchStreetsSuccess,
  FetchStreetsFailure,
  DeleteStreetRequest,
  DeleteStreetSuccess,
  DeleteStreetFailure,
  CreateStreetRequest,
  CreateStreetSuccess,
  CreateStreetFailure,
  UpdateStreetRequest,
  UpdateStreetSuccess,
  UpdateStreetFailure,
  FetchStreetRequest,
  FetchStreetSuccess,
  FetchStreetFailure,
} from './streets.actions'
import { ShowSnackbar } from './../../shared/shared.actions'
import { StreetsService } from './streets.service'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as StreetsTypes from './streets.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class StreetsEffects {
  constructor(
    private actions: Actions,
    private streetsService: StreetsService,
    private router: Router,
  ) {}

  FetchStreets$ = createEffect(() =>
    this.actions.pipe(
      ofType(StreetsTypes.FETCH_STREETS_REQUEST),
      switchMap((action: FetchStreetsRequest) => {
        return this.streetsService.fetchStreets(action.payload).pipe(
          map((result) => {
            return new FetchStreetsSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchStreetsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchStreet$ = createEffect(() =>
    this.actions.pipe(
      ofType(StreetsTypes.FETCH_STREET_REQUEST),
      switchMap((action: FetchStreetRequest) => {
        return this.streetsService.fetchStreet(action.id).pipe(
          map((result) => {
            return new FetchStreetSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchStreetFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteStreet$ = createEffect(() =>
    this.actions.pipe(
      ofType(StreetsTypes.DELETE_STREET_REQUEST),
      switchMap((action: DeleteStreetRequest) => {
        return this.streetsService.deleteStreet(action.id).pipe(
          switchMap((result) => {
            return [new DeleteStreetSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteStreetFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateStreet$ = createEffect(() =>
    this.actions.pipe(
      ofType(StreetsTypes.CREATE_STREET_REQUEST),
      switchMap((action: CreateStreetRequest) => {
        return this.streetsService.createStreet(action.payload).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/streets'])
            return [
              new CreateStreetSuccess(),
              new ShowSnackbar({
                type: 'success',
                message: 'Street created successfully.',
              }),
            ]
          }),
          catchError((err, caught) => {
            return of(new CreateStreetFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateStreet$ = createEffect(() =>
    this.actions.pipe(
      ofType(StreetsTypes.UPDATE_STREET_REQUEST),
      switchMap((action: UpdateStreetRequest) => {
        return this.streetsService.updateStreet(action.id, action.payload).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/streets'])
            return [
              new UpdateStreetSuccess(),
              new ShowSnackbar({
                type: 'success',
                message: 'Street updated successfully.',
              }),
            ]
          }),
          catchError((err, caught) => {
            return of(new UpdateStreetFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
